import { axiosClient } from "../axios";

export function insertNote(data) {
  return axiosClient.post("notes/insert", data);
}
export function updatetNote(data) {
  return axiosClient.post(`notes/${data.id}/update`, data);
}

export function deleteNote(id) {
  return axiosClient.delete(`notes/${id}/delete`);
}
